import { lazy, Suspense } from "react";

const Surface = lazy(() =>
	import("~/common/article/writing-surface").then((module) => ({ default: module.WritingField })),
);
export function WritingField(props: {
	value: string;
	onChange: (value: string) => void;
	label: string;
	disabled?: boolean;
	plain?: boolean;
	article?: boolean;
}) {
	return (
		<Suspense fallback={<p className="hint">{props.label}</p>}>
			<Surface {...props} />
		</Suspense>
	);
}
